import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面未找到 - 蜜桃成熟时电影",
    description: "你访问的页面不存在，可以返回首页或浏览电影分类、影视资讯与演员资料。",
    keywords: "页面未找到,蜜桃成熟时电影",
  });

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1240px] flex-col items-center justify-center gap-4 px-4 py-24 text-center md:px-6 md:py-32">
        <p className="font-heading text-6xl font-bold text-primary-300 md:text-8xl">404</p>
        <h1 className="font-heading text-2xl font-semibold text-foreground-950">这个页面不存在</h1>
        <p className="max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的路径 <span className="text-foreground-800">{location.pathname}</span> 可能已经调整。
          试试从下面的入口继续浏览。
        </p>
        <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/category"
            className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400"
          >
            电影分类
          </Link>
          <Link
            to="/news"
            className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400"
          >
            影视资讯
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}